export function isCidadaoIdoso(idadeCidadao: number): boolean {
  return idadeCidadao >= 60
}
